import * as HttpService from './HttpService'

let namespace = 'employees'

let findAll = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let update = (uuid, body, cb, errorCb) => {
    HttpService.put(namespace + '/' + uuid, body, cb, errorCb)
}

let skills = (uuid, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + uuid + '/skill', params, cb, errorCb)
}

let revenue = (params, cb, errorCb) => {
    HttpService.get(namespace + '/revenue', params, cb, errorCb)
}

let compareResponsibleEmployees = (params, cb, errorCb) => {
    HttpService.get(namespace + '/compare/responsible', params, cb, errorCb)
}

let compareResponsibleEmployeesProjectTypes = (params, cb, errorCb) => {
    HttpService.get(namespace + '/compare/responsible-project-types', params, cb, errorCb)
}

export {
    findAll,
    update,
    skills,
    revenue,
    compareResponsibleEmployees,
    compareResponsibleEmployeesProjectTypes
}



// WEBPACK FOOTER //
// ./src/services/employeeService.js